<!--
    描述： 跟踪审计 柱状图列表页面
    时间： 2020/5/29
    created by zjj
-->
<template>
	<div class="track-layout">
		<div class="Layout-around">
			<!-- 主体 -->
			<div class="track-echart-left"
				 :class="{'leftWidth': leftShow === 0, 'rightWidth': leftShow === 2}">
				<div class="baseForm-header overflow-hidden">
					<span class="text"
						  v-show="leftShow">项目结构 （ 请选择单位工程 ）</span>

					<div class="btnGroups">
                        <el-button type="primary" size="mini" @click="changeShowType">{{ showShenBao ? '切换累计审核产值' : '切换累计申报产值' }}</el-button>
						<el-button type="text"
								   :icon="leftShow !== 0 ? 'el-icon-d-arrow-left' : 'el-icon-arrow-right'"
								   :title="leftShow !== 0 ? '收起到最左侧' : '展开'"
								   @click="changeShow('left')"></el-button>
						<el-button type="text"
								   :icon="leftShow !== 2 ? 'el-icon-d-arrow-right' : 'el-icon-arrow-left'"
								   :title="leftShow !== 2 ? '展开到最右侧' : '收起'"
								   @click="changeShow('right')"></el-button>
					</div>
				</div>
				<div class="h100 around-table"
					 ref="tableContent">
						<el-table :data="tableData"
							  row-key="id"
							  ref="structureTree"
							  :height="tableH"
							  border
							  stripe
							  highlight-current-row
							  default-expand-all
							  @row-click="rowClick"
							  :row-class-name="rowClassName"
							  :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
						<el-table-column prop="cost_name"
										 label="项目名称"
										 min-width="160">
							<template slot-scope="scope"
									  class="myCell">
								<el-tooltip class="item"
											effect="dark"
											:content="scope.row.cost_name"
											placement="right">
									<span class="text-overflow"
										  :class="scope.row.levelType === 0 ? 'cell-text' : 'cell-tooltip'">{{ scope.row.levelType === 0 ? scope.row.cost_name : '' }}</span>
								</el-tooltip>
							</template>
						</el-table-column>
						<el-table-column prop="singleName"
										 label="单项工程名称"
										 show-overflow-tooltip
										 min-width="120">
							<template
									  slot-scope="scope">{{ scope.row.levelType === 1 ? scope.row.cost_name : '' }}</template>
						</el-table-column>
						<el-table-column prop="unitName"
										 min-width="120"
										 show-overflow-tooltip
										 label="单位工程名称">
							<template
									  slot-scope="scope">{{ scope.row.levelType === 2 ? scope.row.cost_name : '' }}</template>
						</el-table-column>
						<el-table-column prop="heTongPrice"
										 width="125"
										 header-align="center"
										 align="right"
										 show-overflow-tooltip
										 :label="`合同价款`">
							<template slot-scope="scope">
								<div>
									{{ unitName === '元' ? scope.row.heTongPrice : (scope.row.heTongPrice/10000).toFixed(2) }}
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="shenBaoAndPiZhunSum"
										 width="165"
										 header-align="center"
										 align="right"
										 show-overflow-tooltip
										 :label="showShenBao ? `累计申报产值` : '累计审核产值'">
							<template slot-scope="scope">
								<div v-if="showShenBao">
									{{ unitName === '元' ? scope.row.shenBaoSum : (scope.row.shenBaoSum/10000).toFixed(2) }}
								</div>
                                <div v-else>
                                    {{ unitName === '元' ? scope.row.piZhunSum : (scope.row.piZhunSum/10000).toFixed(2) }}
                                </div>
							</template>
						</el-table-column>
						<el-table-column prop="piZhunAndshenBaoBalance"
										 width="110"
										 header-align="center"
										 align="right"
										 show-overflow-tooltip
										 :label="`余额 (${unitName})`">
							<template slot-scope="scope">
								<div v-if="showShenBao">
									{{ unitName === '元' ? scope.row.shenBaoBalance : (scope.row.shenBaoBalance/10000).toFixed(2) }}
								</div>
                                <div v-else>
                                    {{ unitName === '元' ? scope.row.piZhunBalance : (scope.row.piZhunBalance/10000).toFixed(2) }}
                                </div>
							</template>
						</el-table-column>
						<el-table-column prop="shenBaoAndPiZhunBiLi"
										 width="120"
										 header-align="center"
										 align="right"
										 show-overflow-tooltip
										 :label="showShenBao ? '累计申报比例' : '累计审核比例'">
                            <template slot-scope="scope">
                                <div>{{ showShenBao ? scope.row.shenBaoBiLi : scope.row.piZhunBiLi }}</div>
                            </template>
						</el-table-column>
						<el-table-column prop="shengYuShenBaoAndPiZhun"
										 width="110"
										 header-align="center"
										 align="right"
										 show-overflow-tooltip
										 :label="showShenBao ? '剩余申报比例' : '剩余审核比例'">
                            <template slot-scope="scope">
                                <div>{{ showShenBao ? scope.row.shengYuShenBao : scope.row.shengYuPiZhun }}</div>
                            </template>
						</el-table-column>
					</el-table>
				</div>
			</div>
			<!-- 右侧表格 -->
			<div class="track-echart-right">
				<!-- 表格主体 -->
				<div id="main">暂无数据</div>
			</div>
		</div>
	</div>
</template>
<script>
import { mapState } from 'vuex'

export default {
	props: {
		// tab切换模式 （0 是申报， 1 是批准）
		navIndex: {
			type: Number,
			default: 0
		},
		//单位类型名称
		unitName: {
			type: String,
			default: ''
		},
		//列表数据
		treeDataList: {
			type: Array,
			default: []
		}
	},
	data() {
		return {
			leftShow: 1, // 左侧是否展示 (0 最左侧， 1 中间， 2 最右侧)
			rightShow: true,
			tableH: 0,
			tableData: [],
			curShowName: '', // 当前图的 标题
			curRow: {}, // 当前点击的row 数据
			// 列过滤数组
			filterColumns: ['biddingPrice', 'money', 'balance'],
			periodsList: [], // 期数数组
            showShenBao: false, // 展示申报还是审核（1 审核， 0 申报）
		}
	},
	created() {
		this.$nextTick(() => {
			this.tableH = this.$refs.tableContent.offsetHeight

			setTimeout(() => {
				if (this.tableData.length > 0) {
					this.periodsList = this.tableData[0].dangQiShenBaoList
					this.$refs.structureTree
						? this.$refs.structureTree.setCurrentRow(
								this.tableData[0]
						  )
						: ''
					this.rowClick(this.tableData[0])
				}
			}, 300)
			// this.initCharts()
		})
	},
	mounted() {
		this.$nextTick(() => {})
	},

	methods: {
        // 切换展示 申报还是审核
        changeShowType() {
            this.showShenBao = !this.showShenBao
        },

		// 移动事件，适应表格
		reseizeChart() {
			let _auditChart = this.$echarts.init(
				document.getElementById('main')
			)

			if (_auditChart) {
				setTimeout(() => {
					_auditChart.resize()
				}, 300)
			}
		},
		// 左侧点击展示/隐藏
		changeShow(type) {
			if (type === 'left') {
				this.leftShow = this.leftShow !== 0 ? 0 : 1
			} else {
				this.leftShow = this.leftShow !== 2 ? 2 : 1
			}
			setTimeout(() => {
				if (this.tableData[0] && this.tableData[0].dangQiShenBaoList.length > 0) {
					this.reseizeChart()
				}
			}, 300)
		},

		// 右侧展开/隐藏
		changeRightShow() {
			this.rightShow = !this.rightShow
			setTimeout(() => {
				if (this.tableData[0] && this.tableData[0].dangQiShenBaoList.length > 0) {
					this.reseizeChart()
				}
			}, 300)
		},

		// 行样式
		rowClassName({ row, rowIndex }) {
			if (row.levelType === 0) {
				return 'project-row'
			} else if (row.levelType === 1) {
				return 'single-row'
			} else if (row.levelType === 2) {
				return 'unit-row'
			}
			return ''
		},

		// 行点击事件
		rowClick(row) {
			this.curRow = {}
			let _pname = this.treeDataList[0].cost_name
			let name = row.cost_name

			// 设置右边结构名字
			if (row.levelType === 0) {
				this.curShowName = name
			} else if (row.levelType === 1) {
				this.curShowName = _pname + ' | ' + name
			} else {
				// 当前结构树ID
                let _item = this.$utils.findTree(this.treeDataList, x => x.id === row.pid)
				let _dname = _item ? _item.item.cost_name : ''
				this.curShowName = _pname + ' | ' + _dname + ' | ' + name
			}
			// 右侧图表
			if (
				row &&
				row.id &&
				row.dangQiShenBaoList &&
				row.dangQiShenBaoList.length > 0
			) {
				this.curRow = row
				setTimeout(() => {
					this.initCharts(row)
				}, 300)
			} else {
                let _auditChart = this.$echarts.init(
				    document.getElementById('main')
			    )

                if (_auditChart) {
                    _auditChart.dispose()
                    document.getElementById('main').innerText = '暂无数据'
                }
            }
		},

		//获取echart图标
		initCharts(row) {
			let _auditChart = this.$echarts.init(
				document.getElementById('main')
			)

			let unitName = this.unitName

			// 定义 x轴 及 数据
			let xArr = []
			// 单期值对象
			let singleObj = {
				list1: [],
				list2: []
			}
			this.periodsList.forEach(x => {
				xArr.push(`第${x.number_periods}期`)
				let _item = row.dangQiShenBaoList.find(
					y => y.number_periods === x.number_periods
				)
				// 申报单期值
				let val =
					_item && _item.cost_value
						? parseFloat(_item.cost_value).toFixed(2)
						: 0
				this.unitName === '元'
					? singleObj.list1.push(val)
					: singleObj.list1.push((val / 10000).toFixed(2))

				let _item_approval = row.dangQiPiZhunList.find(
					y => y.number_periods === x.number_periods
				)
				// 批准单期值
				let val_approval =
					_item_approval && _item_approval.cost_value
						? parseFloat(_item_approval.cost_value).toFixed(2)
						: 0
				this.unitName === '元'
					? singleObj.list2.push(val_approval)
					: singleObj.list2.push((val_approval / 10000).toFixed(2))
			})

			let colorList = ['#CDD169', '#6F9EA7', '#C6866D', '#a52a2a']

			// 累计值对象
			let totalObj = {
				list1: [],
				list2: []
			}

			singleObj.list1.forEach((item, index) => {
				if (index === 0) {
					totalObj.list1.push(item)
				} else {
					let value = (
						parseFloat(item) + parseFloat(totalObj.list1[index - 1])
					).toFixed(2)
					totalObj.list1.push(value)
				}
			})

			singleObj.list2.forEach((item, index) => {
				if (index === 0) {
					totalObj.list2.push(item)
				} else {
					let value = (
						parseFloat(item) + parseFloat(totalObj.list2[index - 1])
					).toFixed(2)
					totalObj.list2.push(value)
				}
			})

			let option = {
				tooltip: {
					trigger: 'axis',
					// trigger: 'none',
					axisPointer: {
						type: 'cross',
						crossStyle: {
							color: '#999'
						}
					},
					formatter: `{b}<br/>
						{a0}： {c0} ${unitName}<br/>
						{a1}： {c1} ${unitName}<br/>
						{a2}： {c2} ${unitName}<br/>
						{a3}： {c3} ${unitName}<br/>`
				},
				title: {
					text: this.curShowName,
					textAlign: 'center',
					top: '5px',
					left: '50%'
				},
				toolbox: {
					feature: {
						restore: {},
						saveAsImage: { show: true }
					}
				},
				dataZoom: [
					{
						show: true,
						realtime: true // 是否实时
					},
					{
						type: 'inside',
						realtime: true,
						// xAxisIndex: [0, 1]
					}
				],
				legend: {
					type: 'scroll',
					top: '40px',
					data: [
						'当期申报产值',
						'当期审核产值',
						'累计申报产值',
						'累计审核产值'
					]
				},
				xAxis: [
					{
						type: 'category',
						data: xArr,
						// axisLine: { onZero: true },
						axisPointer: {
							type: 'shadow',
							// label: {
							// 	formatter: function(params) {
							// 		return (
							// 			params.value +
							// 			(params.seriesData.length
							// 				? '：' +
							// 				  params.seriesData[0].seriesName +
							// 				  ' ' +
							// 				  params.seriesData[0].data +
							// 				  ' ' +
							// 				  unitName +
							// 				  ' ' +
							// 				  params.seriesData[1].seriesName +
							// 				  ' ' +
							// 				  params.seriesData[1].data +
							// 				  ' ' +
							// 				  unitName
							// 				: '')
							// 		)
							// 	}
							// }
						}
					},
					// {
					// 	type: 'category',
					// 	data: xArr,
					// 	axisTick: {
					// 		alignWithLabel: true
					// 	},
					// 	axisLine: {
					// 		onZero: false,
					// 		lineStyle: {
					// 			color: colorList[3]
					// 		}
					// 	},
					// 	axisPointer: {
					// 		label: {
					// 			formatter: function(params) {
					// 				return (
					// 					// '降水量  ' +
					// 					params.value +
					// 					(params.seriesData.length
					// 						? '：' +
					// 						  params.seriesData[0].seriesName +
					// 						  ' ' +
					// 						  params.seriesData[0].data +
					// 						  ' ' +
					// 						  unitName +
					// 						  ' ' +
					// 						  params.seriesData[1].seriesName +
					// 						  ' ' +
					// 						  params.seriesData[1].data +
					// 						  ' ' +
					// 						  unitName
					// 						: '')
					// 				)
					// 			}
					// 		}
					// 	},
					// 	data: xArr
					// }
				],
				yAxis: [
					{
						type: 'value',
						name: this.unitName
					}
				],
				grid: {
					top: '100px',
					left: '15px',
					right: '4%',
					bottom: '10px',
					containLabel: true
				},
				series: [
					{
						name: '当期申报产值',
						type: 'bar',
						itemStyle: {
							color: colorList[1]
						},
						data: singleObj.list1
					},
					{
						name: '当期审核产值',
						type: 'bar',
						itemStyle: {
							color: colorList[2]
						},
						data: singleObj.list2
					},
					{
						name: '累计申报产值',
						type: 'line',
						smooth: true,
						// xAxisIndex: 1,
						itemStyle: {
							color: colorList[1]
						},
						data: totalObj.list1
					},
					{
						name: '累计审核产值',
						type: 'line',
						smooth: true,
						// xAxisIndex: 1,
						itemStyle: {
							color: colorList[2]
						},
						data: totalObj.list2
					}
				]
			}
			_auditChart.setOption(option)

			window.onresize = () => {
				_auditChart.resize()
			}
		}
	},
	computed: {
		...mapState('app', {
			clientSize: state => state.clientSize
		})
	},
	watch: {
		//监听列表数据
		treeDataList: {
			handler: function(arr) {
				this.tableData = JSON.parse(JSON.stringify(arr))
                if (arr.length > 0) {
                    // 去除更多层级
                    let _levelType = this.$utils.filterTree(this.tableData, x => x.levelType === 2)
                    // console.log(_levelType)
                    _levelType.map(x => {
                        x.children = []
                    })
                    this.rowClick(this.tableData[0])
                    this.periodsList = this.tableData[0].dangQiShenBaoList
                }
			},
			deep: true
		},
		clientSize() {
			this.$nextTick(() => {
				this.tableH = this.$refs.tableContent.offsetHeight
			})
		},
		// 单位的切换  （重载表格）
		unitName(val) {
			this.initCharts(this.curRow)
		}
	}
}
</script>
<style scoped lang='less'>
.track-layout {
	overflow: hidden;
	height: 100%;
	border-top: 1px solid #cdcdcd;
	flex: 1;
	.Layout-around {
		display: flex;
		height: 100%;
		.track-echart-left {
			width: 520px;
			height: 100%;
			display: flex;
			flex-direction: column;
			border-right: 1px solid #ccc;

			.baseForm-header {
				color: #07a2ea;
				overflow: hidden;
				span {
					display: inline-block;
					height: 43px;
					line-height: 43px;
				}
				.btnGroups {
					float: right;
					display: flex;
					align-items: center;
					height: 100%;
					box-sizing: border-box;
					justify-content: flex-end;
					flex: 1;
				}
			}
			.around-table {
				flex: 1;
			}
		}
		.leftWidth {
			width: 40px !important;
		}

		.rightWidth {
			width: 100% !important;
		}

		.track-echart-right {
			flex: 1;
			background-color: #fff;
			overflow: auto;

			#main {
				width: 100%;
				height: 100%;
				display: flex;
				align-items: center;
				justify-content: center;
			}
		}
	}
}
</style>